import md5 from 'blueimp-md5'

export function getSignature(obj, method, timeStamp) {
  function sortKey(o) {
    let newO = {}, arr = Object.keys(o), sortArr = arr.sort();
    sortArr.forEach(item => {
      newO[item] = o[item] || o[item]=='0' ? o[item] : '';
    })
    for (let k in newO) {
      if (newO[k].constructor === Array) {
        newO[k] = newO[k].sort();
        newO[k].forEach((tmp, index) => {
          if (tmp.constructor === Object) newO[k][index] = sortKey(tmp);
        })
      }
      if (newO[k].constructor === Object) newO[k] = sortKey(newO[k]);
    }
    return newO;
  }

  // post原样处理 get方法取对象第一层排序
  let key = '', json = sortKey(obj);
  if (method == 'post') {
    key = JSON.stringify(json) === '{}' ? `{}${timeStamp}` : `${JSON.stringify(json)}${timeStamp}`;
  } else {
    let str = '';
    for (let k in json) {
      str += `${k}=${json[k]}&`
    }
    let arr = str.split('&') || [];
    arr.length -= 1;
    key = `${arr.join('&')}${timeStamp}`;
  }
  let sign = md5(key, '90de934b794347918f0fd27a12d02c3c');

  return sign;
}

export const getCurRouter = (pathname, rlist=[], isChild) => {   //获取当前路由组件
  let _cur = null;
  for(let i=0; i<rlist.length; i++){
    let item = rlist[i], { component, path, children } = item;
    if (_cur) break;
    if (component && pathname == path){   //一级菜单index
      _cur = !isChild ? item : {...item, isChild: true};
      break;
    }
    if (component && pathname != path && children) _cur = getCurRouter(pathname, children, 'isChild');   //一级菜单index的子菜单
    if (!component && children) _cur = getCurRouter(pathname, children, 'isChild');    //一级菜单(需要重定向到子菜单)
  }
  return _cur;
}

export const splitUrlParams = (url) => {     //截取路径上的参数
  let _obj = {}, _sptArr = (url.split('?')[1] || '').split('&');
  _sptArr.forEach(item => {
    let _arr = (item || '').split('=');
    if (_arr[0]) _obj[_arr[0]] = _arr[1];
  })
  console.log('---路径参数----', _obj);
  return _obj;
}

export const setData = (hookSetFun, data, cb) => {    //Hooks中setState方法 data:需要保存的对象  cb:回调函数
  hookSetFun(pre => {
    let _newState = { ...pre, ...data };
    cb && cb(_newState);
    return _newState;
  })
}